import { EngineUtils } from '../services/EngineUtils.js';

type Primitive = string | number | boolean;
// type EngineType = Primitive | MLString | BigNumber;

/***
 * Supports set for all engine type values
 */
export class ObjectHashSet {
  primitiveSet = new Set<Primitive>();
  referenceSet = new Map<string, any>();

  add(value: unknown) {
    if (primitiveTypeGuard(value)) {
      this.primitiveSet.add(value);
    } else {
      this.referenceSet.set(EngineUtils.hash(value), value);
    }
  }

  has(value: unknown): boolean {
    if (primitiveTypeGuard(value)) {
      return this.primitiveSet.has(value);
    } else {
      return this.referenceSet.has(EngineUtils.hash(value));
    }
  }

  delete(value: unknown) {
    if (primitiveTypeGuard(value)) {
      this.primitiveSet.delete(value);
    } else {
      this.referenceSet.delete(EngineUtils.hash(value));
    }
  }

  toArray(): any[] {
    const primitives = Array.from(this.primitiveSet);
    const referenceValues = Array.from(this.referenceSet.values());
    return primitives.concat(referenceValues);
  }
}

function primitiveTypeGuard(value: unknown): value is Primitive {
  return typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean';
}
